import { NamePath } from "antd/es/form/interface";


export interface ValidationConstraints {
    [key:string]: string
}
export interface ValidationError {
    target: any,
    value: string,
    property: NamePath,
    children: ValidationError[],
    constraints: ValidationConstraints
    
}
export interface APIValidationErrorResponse {
    message: string,
    context: ValidationError[],
    error: any[]
}

export class APIValidationError extends Error {

    public response!:APIValidationErrorResponse;

    constructor(response: APIValidationErrorResponse) {
        super();
        // normalise to avoid undefined in callers
        this.response = {
            message: response?.message ?? "Unexpected error",
            context: response?.context ?? [],
            error: response?.error ?? []
        };
    }

    toString() : string {
         return JSON.stringify({
            type: "APIValidationError",
            response: this.response
         }, null, 3)
    }
}